// src/pages/jobs/JobCard.jsx

import React from "react";

const JobCard = ({ job, onSelect }) => {
  return (
    <div
      className="card h-100 shadow-lg border-0 p-4 rounded-3"
      style={{ transition: "transform 0.2s", cursor: "pointer" }}
    >
      <div className="mb-3">
        <span className="badge bg-primary mb-2">{job.program}</span>
        <h5 className="mt-2 fw-semibold">{job.title}</h5>
      </div>

      <ul
        className="list-unstyled mb-4"
        style={{ fontSize: "1rem", lineHeight: "1.6" }}
      >
        <li>
          <strong>دیپارتمنت:</strong> {job.department}
        </li>
        <li>
          <strong>درجه تحصیلی:</strong> {job.level}
        </li>
        <li>
          <strong>تعداد بست:</strong> {job.vacancies}
        </li>
        <li>
          <strong>محل وظیفه:</strong>
          {job.province}
        </li>
      </ul>

      <button
        className="btn ss-btn w-100 mt-auto d-flex align-items-center justify-content-center"
        onClick={() => onSelect(job)}
        style={{
          borderRadius: "12px",
          height: "36px",
          padding: "0 12px",
          fontSize: "0.95rem",
        }}
      >
        مشاهده جزئیات
      </button>
    </div>
  );
};

export default JobCard;
